module.exports = __webpack_public_path__ + "teqbahn-assets/media/32.8694b88a.png";